var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-circle full\" ng-repeat=\"i in gradeRange\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"fa fa-circle empty\" ng-repeat=\"i in restRange\"\u003E\u003C\u002Fi\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/directives/circle-rating/view.jade
// module id = 718
// module chunks = 1